import { Link } from "react-router-dom";
import { PrevPage } from "../hooks/use_prev_page";

export function LinkWithPreviousPage(
	props: Omit<React.ComponentProps<typeof Link>, "to"> & {
		prev_page: PrevPage;
		to: {
			pathname: string;
			search?: string;
			hash?: string;
			state?: Record<string, unknown>;
		};
	}
) {
	return (
		<Link
			{...props}
			to={{
				...props.to,
				state: { ...props.to?.state, prev_page: props.prev_page },
			}}
		></Link>
	);
}
